/* ==========================================================
 * variant-loader-lock.js   v3
 * 等待变体类 App（GLO Color Swatch / Globo Product Options）初始化完成，
 * 在此之前禁用尺码/颜色选择器，避免错误库存状态（sold out 误判）
 *
 * 版本历史：
 *   v1 首版
 *   v2 去掉中央大字遮罩；无变体商品立即解锁
 *   v3 【重要】增加"App 卸载容错"：
 *      老板已卸载 GLO Color Swatch，但 v2 仍在等 'gsw-swatch-installed'，
 *      该 class 永远不会出现 → 锁会卡满 MAX_WAIT 才放开，比不锁还慢。
 *      v3 做法：DOM 就绪后超过宽限期仍找不到该 App 的任何痕迹，
 *              就判定它已卸载，不再等待。
 *
 * 注意：本文件必须在 <head> 内【同步】引入（不能加 defer），
 *       否则会晚于 Globo 执行，锁就失去意义。
 * ========================================================== */
(function () {
  'use strict';

  var LOADING_CLASS = 'variants-loading';
  var READY_CLASS   = 'variants-ready';
  var MAX_WAIT_MS   = 4000;   // 绝对兜底
  var POLL_MS       = 40;
  var GRACE_MS      = 900;    // DOM 就绪后给 App 出现的宽限期

  var root = document.documentElement;
  var startedAt = Date.now();
  var done = false;

  var domReady = false;
  var domReadyAt = 0;

  root.classList.add(LOADING_CLASS);

  /* ---------- 检测 App 是否还在（用于"已卸载"判定） ---------- */

  function gloDetected() {
    try {
      if (window.GloboSwatch || window.gswSwatch) return true;
      if (document.querySelector('script[src*="glo-color-swatch"],script[src*="globo-swatch"],script[src*="gsw"]')) return true;
      if (document.querySelector('[class*="gsw-"],[id*="gsw"]')) return true;
    } catch (e) {}
    return false;
  }

  function globoDetected() {
    try {
      if (window.GPOConfigs || window.GPO) return true;
      if (document.getElementById('globo_option_app')) return true;
      if (document.querySelector('[id^="globo-form-"]')) return true;
      if (document.querySelector('script[src*="globo-product-options"]')) return true;
    } catch (e) {}
    return false;
  }

  /* ---------- 就绪判定 ---------- */

  function isGloReady() {
    // GLO 已初始化完成
    if (root.classList.contains('gsw-swatch-installed')) return true;
    // GLO 已卸载：DOM 就绪 + 过了宽限期 + 找不到任何痕迹 → 不用等它
    if (domReady && (Date.now() - domReadyAt) > GRACE_MS && !gloDetected()) return true;
    return false;
  }

  function isGloboReady() {
    if (document.getElementById('globo_option_app') ||
        document.querySelector('[id^="globo-form-"]')) return true;
    if (window.GPO && window.GPO.appReady) return true;
    // Globo 已卸载：同理不再等待
    if (domReady && (Date.now() - domReadyAt) > GRACE_MS && !globoDetected()) return true;
    return false;
  }

  /* ---------- 无变体商品：没必要锁 ---------- */

  function hasVariantPicker() {
    return !!(
      document.querySelector('select[name="id"]') ||
      document.querySelector('input[name="id"]')  ||
      document.querySelector('[class*="swatch"]') ||
      document.querySelector('[class*="variant"]')
    );
  }

  function recheckVariantStock() {
    var sels = document.querySelectorAll('select[name="id"], input[name="id"]');
    for (var i = 0; i < sels.length; i++) {
      try {
        sels[i].dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    }
    try {
      document.dispatchEvent(new CustomEvent('globo:variant:recheck'));
    } catch (e) {}
  }

  function markReady(reason) {
    if (done) return;
    done = true;

    root.classList.remove(LOADING_CLASS);
    root.classList.add(READY_CLASS);
    try { clearInterval(timer); } catch (e) {}

    setTimeout(recheckVariantStock, 80);
    setTimeout(recheckVariantStock, 350);

    if (window.console && console.info) {
      console.info(
        '[variant-loader-lock] 已解锁 · 用时 ' + (Date.now() - startedAt) + 'ms · 原因: ' + reason
      );
    }
  }

  var timer = setInterval(function () {
    if (isGloReady() && isGloboReady()) {
      markReady('apps-ready');
    } else if (Date.now() - startedAt >= MAX_WAIT_MS) {
      markReady('timeout');
    }
  }, POLL_MS);

  function onDomReady() {
    domReady = true;
    domReadyAt = Date.now();
    // 压根没有变体选择器 → 立即解锁
    if (!done && !hasVariantPicker()) {
      markReady('no-variant-picker');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onDomReady);
  } else {
    onDomReady();
  }

  setTimeout(function () { markReady('failsafe'); }, MAX_WAIT_MS + 300);

  window.__variantLoaderLock = {
    isGloReady: isGloReady,
    isGloboReady: isGloboReady,
    gloDetected: gloDetected,
    globoDetected: globoDetected,
    markReady: markReady
  };
})();
